import { dateFormatFr, daysDiffToday } from '@/utils/data/date'
import { INDETERMINATE_STATUS } from '@/consts/app'
import { userName } from '@/utils/data/agents'
import {
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ADDRESS,
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_DROPDOWN,
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_MANAGER,
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ROOT,
  generateAddressToken
} from '@/consts/data/contract'

export const EXPIRATIONS_RELATIVE_ALERTS = [
  {
    name: 'Expiré',
    value: 0,
    color: 'negative'
  },
  {
    name: 'Expire bientôt (-30j)',
    value: 30,
    color: 'orange'
  },
  {
    name: 'A surveiller (-60j)',
    value: 60,
    color: 'positive'
  },
  {
    name: 'Prochainement (-90j)',
    value: 90,
    color: 'blue-9'
  }
]

export const getRelativeAlert = (v) =>
  _.find(EXPIRATIONS_RELATIVE_ALERTS, (a) => daysDiffToday(v) < a.value) ||
  INDETERMINATE_STATUS

export const DATA_CONTRACTS_COLUMNS = [
  {
    name: 'agent',
    label: 'Agent',
    sortable: true,
    format: (val, row) => userName(row.agent.user),
    classes: 'sticky',
    headerClasses: 'sticky'
  },
  {
    name: 'contract',
    label: 'Type',
    field: 'contract',
    sortable: false
  },
  {
    name: 'endDate',
    label: 'Date',
    field: 'endDate',
    sortable: true,
    format: dateFormatFr
  }
]

export const DATA_CONTRACTS_INDEXED_COLUMNS = _.keyBy(DATA_CONTRACTS_COLUMNS, 'name')

export const DATA_AGENTS_CONTRACTS_EDITOR_TOKENS_ROOT = [
  {
    value: 'agent.email',
    label: `Email de l'agent`
  },
  {
    value: 'agent.fullname',
    label: `Nom complet de l'agent`
  },
  {
    value: 'agent.firstname',
    label: `Prénom de l'agent`
  },
  {
    value: 'agent.lastname',
    label: `Nom de l'agent`
  },
  {
    value: 'agent.phone',
    label: `Téléphone de l'agent`
  }
]
export const DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS_ADDRESS =
  generateAddressToken('agent.address', `de l'agent`)

export const DATA_AGENTS_CONTRACTS_EDITOR_TOKENS_INFOS = [
  {
    value: 'agent.agentInfos.type',
    label: `Type d'agent`
  },
  {
    value: 'agent.agentInfos.birthDate',
    label: `Date de naissance de l'agent`
  },
  {
    value: 'agent.agentInfos.birthLocation',
    label: `Lieu de naissance de l'agent`
  },
  {
    value: 'agent.agentInfos.nationality',
    label: `Nationalité de l'agent`
  },
  {
    value: 'agent.agentInfos.registrationNumber',
    label: `Matricule de l'agent`
  },
  {
    value: 'agent.agentInfos.cardNumber',
    label: `Numéro de carte professionnelle de l'agent`
  },
  {
    value: 'agent.agentInfos.externalCompanyName',
    label: `Nom de l'employeur de l'agent`
  },
  {
    value: 'agent.agentInfos.socialSecurityNumber',
    label: `Numéro de sécurité sociale de l'agent`
  },
  {
    value: 'agent.agentInfos.bankDetails',
    label: `Coordonnées bancaires de l'agent`
  },
  {
    value: 'agent.agentInfos.sstNumber',
    label: `Numéro SST de l'agent`
  }
]
export const DATA_AGENTS_CONTRACTS_EDITOR_TOKENS = [
  ...DATA_AGENTS_CONTRACTS_EDITOR_TOKENS_ROOT,
  ...DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS_ADDRESS,
  ...DATA_AGENTS_CONTRACTS_EDITOR_TOKENS_INFOS,
  ...DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ROOT,
  ...DATA_CONTRACT_AGENCY_EDITOR_TOKENS_MANAGER,
  ...DATA_CONTRACT_AGENCY_EDITOR_TOKENS_ADDRESS
]

export const DATA_AGENTS_CONTRACTS_EDITOR_TOKENS_DROPDOWN = [
  {
    label: 'Agent',
    sub: true,
    value: 'user',
    data: [
      {
        label: 'Informations',
        sub: true,
        value: 'agent.agentInfos',
        data: DATA_AGENTS_CONTRACTS_EDITOR_TOKENS_INFOS
      },
      {
        label: 'Adresse',
        sub: true,
        value: 'agent.address',
        data: DATA_CUSTOMERS_CONTRACTS_EDITOR_TOKENS_ADDRESS
      },
      ...DATA_AGENTS_CONTRACTS_EDITOR_TOKENS_ROOT
    ]
  },
  DATA_CONTRACT_AGENCY_EDITOR_TOKENS_DROPDOWN
]

export const DATA_AGENTS_INDEXED_CONTRACTS_EDITOR_TOKENS = _.keyBy(DATA_AGENTS_CONTRACTS_EDITOR_TOKENS, 'value')
